export enum TAB_PAYMENTS_COMPONENT {
  BILLING_PERIODS = 'BillingPeriodsModalComponent',
}
